import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52ab1e7e")

_pushScopeId("data-v-52ab1e7e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("アプリのロゴを編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_M_icon_file_input = _resolveComponent("M-icon-file-input")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_M_icon_file_input, {
          label: "アプリのロゴ ※ロゴが未設定の場合はみんがくのロゴが表示されます",
          "img-size": "wide",
          "img-type": "logo",
          src: _ctx.convertedLogoUrl,
          "is-selection-active": _ctx.isIconSelectionActive,
          onSelectionActiveChange: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.isIconSelectionActive = !_ctx.isIconSelectionActive
          )),
          onAdd: _ctx.addIcon,
          onDelete: _ctx.deleteIcon
        }, null, 8, ["src", "is-selection-active", "onAdd", "onDelete"])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        onClick: _ctx.update
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
})